import dayjs from 'dayjs';
import { i18n } from '@tencent/vb-web-base';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';

import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-hk';
import 'dayjs/locale/en-gb';

dayjs.extend(AdvancedFormat);

const MonthEnum: { [key: number]: string } = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

const MonthEnumShort: { [key: number]: string } = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};
export function formatBySep(date: dayjs.ConfigType, sep = '/'): string {
  const str = ['YYYY', 'MM', 'DD'].join(sep);
  return dayjs(date).format(str);
}

export function formatI18n(date: dayjs.ConfigType) {
  const lang = i18n.getLang();
  if (lang === 'en-GB') {
    return dayjs(date).format('Do MMM');
  }
  return dayjs(date).format('MMMDo');
}

export function setDayjsLocale(locale: string) {
  dayjs.locale(locale);
}
export function initLanguage(lan: string) {
  switch (lan) {
    case 'en-GB':
      setDayjsLocale('en-gb');
      break;
    case 'zh-CN':
      setDayjsLocale('zh-cn');
      break;
    case 'zh-HK':
      setDayjsLocale('zh-hk');
      break;
    default:
      setDayjsLocale('zh-hk');
  }
}

export function formatBillListDate(date: dayjs.ConfigType) {
  return dayjs(date).format('YYYY-MM-DD');
}

export function getMonth(month: number, short = false) {
  if (i18n.getLang() === 'en-GB') {
    return short ? MonthEnumShort[month] : MonthEnum[month];
  }
  return `${month}`;
}

export function addDate(date: dayjs.ConfigType, addDay: number) {
  return dayjs(date).add(addDay, 'day').format('YYYY-MM-DD');
}
